import { Button } from "react-bootstrap";
import { MdDownload } from "react-icons/md";

export default function ExportButtons({ exportFileMutation }) {
  const handleExportCsv = async () => {
    try {
      const { blob, filename } = await exportFileMutation.mutateAsync();

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error exporting CSV:", error);
    }
  };

  return (
    <Button
      variant="outline-primary"
      size="sm"
      onClick={handleExportCsv}
      disabled={exportFileMutation.isPending}
    >
      <MdDownload size={16} />{" "}
      {exportFileMutation.isPending
        ? "Pripravljamo izvoz podatkov..."
        : "Izvozi CSV"}
    </Button>
  );
}
